export default __webpack_public_path__ + "static/DF_2020-ed1558fc2b97a322bf21159b923deda1.pdf";